export default __webpack_public_path__ + "static/media/channel_mojitok_galaxy_icon.5c1ae1fb.svg";